module.exports = __webpack_public_path__ + "static/img/m_name.355f4df.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/wxsjglm/m_name.png
// module id = kTIe
// module chunks = 7